'use client'

import React, { useEffect, useState, useRef } from 'react'
// import { Link, useParams } from 'react-router-dom'
import Link from 'next/link'
// let Fancybox = null;
// import '@fancyapps/ui/dist/fancybox/fancybox.css'
import '@fancyapps/ui/dist/fancybox.css'
// import Project_details_form from '../components/forms/Project_details_form'
import { Swiper, SwiperSlide } from 'swiper/react'
import {
  Navigation,
  Pagination,
  Autoplay,
  Keyboard,
  Scrollbar
} from 'swiper/modules'
import {
  setIsOpenInq,
  setProjectsFullListDetail
} from '../store/features/projectSlice'
import { useDispatch, useSelector } from 'react-redux'
import Project_details_form from './forms/Project_details_form'
import Image from 'next/image'

function Project_details({
  // propertylist,
  // isOpenInq,
  // setIsOpenInq,
  // projects_full_list_detail,
  // setProjects_full_list_detail,
  // countryList,
  propertyDetail
}) {
  // const [propertyDetail, setPropertyDetail] = useState(null)
  const [overlayLoading, setOverlayLoading] = useState(true)
  const [isMobilescreen, setIsMobilescreen] = useState(false)
  const [walkthroughVideoArray, setWalkthroughVideoArray] = useState(null)
  const [mediaTab, setMediaTab] = useState('media-walkthrough')
  const [interiorArray, setInteriorArray] = useState([])
  const [exteriorArray, setExteriorArray] = useState([])
  const [categoryTitle, setCategoryTitle] = useState('')
  const [videoLink, setVideoLink] = useState('')
  // const [Swiperlist, setSwiperlist] = useState([])
  const [view_moreless_toggleF, setView_moreless_toggleF] = useState(false)

  const dispatch = useDispatch()
  const isOpenInq = useSelector((state) => state.project.isOpenInq)
  const projects_full_list_detail = useSelector(
    (state) => state.project.projects_full_list_detail
  )

  // const isSmall = galleryImages.length <= 2;

  useEffect(() => {
    if (window.innerWidth < 767) setIsMobilescreen(true)

    setTimeout(() => {
      setOverlayLoading(false)
    }, 1500)
  }, [])

  const setActiveTabMedia = function (tab) {
    setMediaTab(tab)
  }

  function extractVideoId(url) {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    const match = url.match(regex)
    return match ? match[1] : null
  }

  const handleInq = (bool) => {
    if (bool && propertyDetail) {
      dispatch(setProjectsFullListDetail(propertyDetail))
    }
    dispatch(setIsOpenInq(bool))
  }

  useEffect(() => {
    // if (propertylist) {
    // const property = propertylist.filter((p) => p.slug == slug)
    // // setPropertyDetail(property[0])
    // setProjects_full_list_detail(property[0])
    dispatch(setProjectsFullListDetail(propertyDetail))

    if (propertyDetail.virtual_data) {
      propertyDetail.virtual_data.forEach((video) => {
        if (video.type == 'walk-through') {
          let videoId = extractVideoId(video.url)

          if (videoId) {
            setWalkthroughVideoArray(
              `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&mute=1&loop=1&playlist=${videoId}&enablejsapi=1&controls=0`
            )
          }
        }
      })
    }

    if (propertyDetail) {
      const interior = []
      const exterior = []
      // console.log(property[0].gallery_data[0].image);
      if (propertyDetail.gallery_data[0].image) {
        propertyDetail.gallery_data[0].image.forEach((item) => {
          if (item.title === 'interior') {
            interior.push(item)
          } else if (item.title === 'exterior') {
            exterior.push(item)
          }
        })
        setInteriorArray(interior)
        setExteriorArray(exterior)

        // Set default selected category
        if (interior.length > 0 && exterior.length > 0) {
          setCategoryTitle('interior')
        } else if (interior.length === 0 && exterior.length > 0) {
          setCategoryTitle('exterior')
        } else if (interior.length > 0 && exterior.length === 0) {
          setCategoryTitle('interior')
        } else {
          setCategoryTitle('')
        }
      }

      setVideoLink(constructionVideoLinks[propertyDetail.project_id])
      // setSwiperlist(getConstructionData(propertyDetail.project_id))
      // console.log(videoLink);
    }

    // console.log(interiorArray);
    // console.log(exteriorArray);
    // console.log(propertyDetail)
    // }
  }, [])

  const getConstructionData = (id) => {
    // console.log('Get List', id)
    // console.log('Get List type', typeof id)
    if (id == 590) {
      return deshnaConstructionData
    } else if (id == 602) {
      return planetConstructionData
    } else if (id == 621) {
      return goodWillTowerConstructionData
    }

    return []
  }

  const constructionVideoLinks = {
    590: 'https://youtu.be/lRMf_DeypXQ?si=eme3wYdvqkzfJ574',
    602: 'https://youtu.be/Za8o9bdN7bc',
    621: 'https://youtu.be/VGAlUAWqvws?si=2_y5Hd36TzoubSHY'
  }

  // useEffect(() => {
  //   let fancyboxInstance;

  //   import("@fancyapps/ui").then(({ Fancybox }) => {
  //     Fancybox.close();

  //     fancyboxInstance = Fancybox.bind("[data-fancybox=walk-through]", {
  //       autoStart: false,
  //       preload: false,

  //       Carousel: {
  //         infinite: false,
  //       },
  //     });
  //   });

  //   return () => {
  //     if (fancyboxInstance) {
  //       fancyboxInstance.forEach((instance) => instance.destroy());
  //     }
  //   };
  // }, [propertyDetail]);

  useEffect(() => {}, [propertyDetail])

  useEffect(() => {
    const timer = setTimeout(() => {
      import('@fancyapps/ui').then(({ Fancybox }) => {
        Fancybox.bind('[data-fancybox]', {
          Thumbs: false,
          Toolbar: true
        })
      })

      return () => Fancybox.destroy()
    }, 500)

    return () => clearTimeout(timer)
  }, [propertyDetail])

  useEffect(() => {
    if (typeof window != undefined) {
      window.addEventListener('scroll', function () {
        let progressStatus = document.getElementById('progress')
        let sampleFlat = document.querySelector('.full-width-video-sample')

        if (sampleFlat) {
          let temp = sampleFlat.getBoundingClientRect()
          if (temp.top < 500) {
            sampleFlat.classList.add('active')
          } else {
            sampleFlat.classList.remove('active')
          }
        }

        if (progressStatus) {
          let temp = progressStatus.getBoundingClientRect()
          // console.log(temp)
          if (temp.top < 700) {
            progressStatus.classList.add('active')
          }
        }
      })
    }
  }, [])

  const handleGalleryCategory = (type) => {
    setCategoryTitle(type)
  }

  const deshnaConstructionData = [
    {
      image: '/images/deshna/construction-image/05.jpg'
    },
    {
      image: '/images/deshna/construction-image/06.jpg'
    },
    {
      image: '/images/deshna/construction-image/07.jpg'
    },
    {
      image: '/images/deshna/construction-image/11.jpg'
    },
    {
      image: '/images/deshna/construction-image/14.jpg'
    }
    // {
    //     image: "/images/deshna/construction-image/15.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/16.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/17.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/02.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/03.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/04.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/08.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/09.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/10.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/12.jpg",
    // },
    // {
    //     image: "/images/deshna/construction-image/13.jpg",
    // },
  ]

  const planetConstructionData = [
    // {
    //     image : "/images/planet/construction/01.jpg",
    // },
    {
      image: '/images/planet/construction/04.jpg'
    },
    {
      image: '/images/planet/construction/03.jpg'
    },
    {
      image: '/images/planet/construction/02.jpg'
    },
    {
      image: '/images/planet/construction/08.jpg'
    },
    {
      image: '/images/planet/construction/12.jpg'
    }
    // {
    //     image : "/images/planet/construction/05.jpg",
    // },
    // {
    //     image : "/images/planet/construction/06.jpg",
    // },
    // {
    //     image : "/images/planet/construction/07.jpg",
    // },
    // {
    //     image : "/images/planet/construction/09.jpg",
    // },
    // {
    //     image : "/images/planet/construction/10.jpg",
    // },
    // {
    //     image : "/images/planet/construction/11.jpg",
    // },
  ]

  const goodWillTowerConstructionData = [
    // {
    //     image : "/images/goodwill-tower/construction/01.jpg",
    // },
    // {
    //     image : "/images/goodwill-tower/construction/02.jpg",
    // },
    {
      image: '/images/goodwill-tower/construction/02.jpg'
    },
    {
      image: '/images/goodwill-tower/construction/05.jpg'
    },
    {
      image: '/images/goodwill-tower/construction/06.jpg'
    },
    {
      image: '/images/goodwill-tower/construction/07.jpg'
    },
    {
      image: '/images/goodwill-tower/construction/14.jpg'
    }
    // {
    //     image : "/images/goodwill-tower/construction/04.jpg",
    // },
    // {
    //     image : "/images/goodwill-tower/construction/05.jpg",
    // },
    // {
    //     image : "/images/goodwill-tower/construction/09.jpg",
    // },
    // {
    //     image : "/images/goodwill-tower/construction/10.jpg",
    // },
    // {
    //     image : "/images/goodwill-tower/construction/11.jpg",
    // },
    // {
    //     image : "/images/goodwill-tower/construction/12.jpg",
    // },
    // {
    //     image : "/images/goodwill-tower/construction/13.jpg",
    // },
    // {
    //     image : "/images/goodwill-tower/construction/14.jpg",
    // },
  ]

  const bottomStripRef = useRef(null)
  const floatingBtnRef = useRef(null)

  const view_moreless_toggle_close = () => {
    setView_moreless_toggleF(false)
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      const windowHeight = window.innerHeight
      const documentHeight = document.body.scrollHeight
      const remainingDistance = documentHeight - (scrollTop + windowHeight)

      const bottomStrip = bottomStripRef.current
      const floatingBtn = floatingBtnRef.current

      if (!bottomStrip || !floatingBtn) return

      if (scrollTop > 600 && remainingDistance > 600) {
        bottomStrip.classList.add('showStrip')
        floatingBtn.classList.add('active')
      } else if (scrollTop < 200) {
        bottomStrip.classList.remove('showStrip')
        floatingBtn.classList.remove('active')
      } else if (remainingDistance >= 600) {
        setTimeout(() => {
          bottomStrip.classList.add('showStrip')
          floatingBtn.classList.add('active')
        }, 100)
      }

      if (remainingDistance < 600) {
        setTimeout(() => {
          bottomStrip.classList.remove('showStrip')
          floatingBtn.classList.remove('active')
        }, 100)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      <div className="detail_wrapper">
        {/* {propertyDetail ? ( */}
        <div className="reecosys-main-wrapper" id="reecosys-main-wrapper">
          <div id="reecosys-project-detail-wrapper" className="relative">
            <section
              className="reecosys-section relative overflow"
              id="reecosys-project-detail-section-2"
            >
              {propertyDetail.banners_data.images?.length > 0 && (
                <div>
                  {propertyDetail.banners_data.images[0].image_web_type ==
                    'image' &&
                    propertyDetail.banners_data.images[0].image_web_full && (
                      <div
                        className="project_banner_image relative"
                        style={{ height: '100vh' }}
                      >
                        {propertyDetail.project_id == 602 &&
                          !isMobilescreen && (
                            <Image
                              fetchPriority="high"
                              src={`${propertyDetail.banners_data.images[0].image_web_full}&h=1440&w=2560&q=100`}
                              alt={propertyDetail.project_title}
                              className="gallery-images  image-cover"
                              style={{ objectPosition: 'center 80%' }}
                              fill
                              priority
                            />
                          )}
                        {propertyDetail.project_id == 602 && isMobilescreen && (
                          <Image
                            fetchPriority="high"
                            src={`${propertyDetail.banners_data.images[1].image_web_full}&h=1920&w=1080&q=100`}
                            alt={propertyDetail.project_title}
                            className="gallery-images visibe-xs image-cover"
                            fill
                            priority
                          />
                        )}
                        {propertyDetail.project_id == 621 &&
                          !isMobilescreen && (
                            <Image
                              fetchPriority="high"
                              fill
                              priority
                              src={`${propertyDetail.banners_data.images[0].image_web_full}&w=1920&q=100`}
                              alt={propertyDetail.project_title}
                              className="gallery-images image-cover"
                            />
                          )}
                        {propertyDetail.project_id == 621 && isMobilescreen && (
                          <Image
                            fetchPriority="high"
                            fill
                            priority
                            src={`${propertyDetail.banners_data.images[1].image_web_full}&h=1920&w=1080&q=100`}
                            alt={propertyDetail.project_title}
                            className="gallery-images image-cover"
                          />
                        )}
                        {propertyDetail.project_id != 602 &&
                          propertyDetail.project_id != 621 &&
                          !isMobilescreen && (
                            <Image
                              fetchPriority="high"
                              fill
                              priority
                              src={`${propertyDetail.banners_data.images[0].image_web_full}&h=1440&w=2560&q=100`}
                              alt={propertyDetail.project_title}
                              className="gallery-images image-cover"
                            />
                          )}
                        {propertyDetail.project_id != 602 &&
                          propertyDetail.project_id != 621 &&
                          isMobilescreen && (
                            <Image
                              fetchPriority="high"
                              fill
                              priority
                              src={`${propertyDetail.banners_data.images[1].image_web_full}&h=1920&w=1080&q=100`}
                              alt={propertyDetail.project_title}
                              className="gallery-images image-cover"
                            />
                          )}
                        {propertyDetail.project_id != 602 && (
                          <div className="project_banner_overlay2"></div>
                        )}
                        {propertyDetail.project_id != 602 && (
                          <div className="project_banner_overlay"></div>
                        )}
                        {/* <div
                          className={`animationOverlay ${
                            overlayLoading ? '' : 'active'
                          }`}
                        ></div> */}
                      </div>
                    )}
                </div>
              )}
              {(propertyDetail.banner_data.title ||
                propertyDetail.size_price ||
                propertyDetail.location ||
                propertyDetail.status?.length > 0) &&
                propertyDetail.project_id != 602 && (
                  <div
                    className={`project-detail-info-banner ${
                      propertyDetail.project_id == 621 ? 'goodwillText' : ''
                    }`}
                  >
                    <div
                      className=""
                      // data-aos={
                      //   propertyDetail.banners_data.images[0].image_web_full
                      //     ? 'fade-in'
                      //     : ''
                      // }
                      // data-aos-delay="1200"
                      // data-aos-duration="1000"
                    >
                      <div className="inner-flex">
                        <div className="banner_content-flex ">
                          <div className="section-content statusTag">
                            <p className="uppercase white-color">
                              {propertyDetail.status == 'under construction'
                                ? 'Ongoing'
                                : propertyDetail.status}
                            </p>
                          </div>

                          {/* ng-if="propertyDetail.project_logo_full  && propertyDetail.project_id != 590 && propertyDetail.project_id != 547 && propertyDetail.project_id != 621" */}
                          {propertyDetail.project_logo_full &&
                            propertyDetail.project_id != 590 &&
                            propertyDetail.project_id != 547 &&
                            propertyDetail.project_id != 621 && (
                              <div className="location-logo-icon ">
                                <img
                                  src={propertyDetail.project_logo_full}
                                  alt=""
                                  style={{ filter: 'brightness(100)' }}
                                />
                              </div>
                            )}
                          {propertyDetail.project_logo_full &&
                            propertyDetail.project_id == 621 && (
                              <div className="location-logo-icon goodWillLogo">
                                <img
                                  src={propertyDetail.project_logo_full}
                                  alt=""
                                  style={{ filter: 'brightness(100)' }}
                                />
                              </div>
                            )}
                          {propertyDetail.project_logo_full &&
                            (propertyDetail.project_id == 590 ||
                              propertyDetail.project_id == 547) && (
                              <div className="location-logo-icon">
                                <img
                                  src={propertyDetail.project_logo_full}
                                  alt=""
                                  style={{
                                    filter: 'invert(1) brightness(100)'
                                  }}
                                />
                              </div>
                            )}
                          {!propertyDetail.project_logo_full && (
                            <div className="banner-title">
                              <h1 className="text-center white-color">
                                {propertyDetail.project_title}
                              </h1>
                            </div>
                          )}
                          {propertyDetail.status?.length > 0 && (
                            <div className="banner-detail-row banner_sub_info">
                              <div className="banner-detail-row banner_sub_info">
                                {propertyDetail.size_price && (
                                  <div className="project-information-div ">
                                    <div className="building-icon">
                                      <img
                                        src="/images/icon/building_white.png"
                                        alt={propertyDetail.size_price}
                                      />
                                    </div>
                                    <div className="content-size-div project_banner_info_size mt4">
                                      <p className="capitalize">
                                        {propertyDetail.size_price}
                                      </p>
                                    </div>
                                  </div>
                                )}
                                {propertyDetail.location && (
                                  <div className="project-information-div">
                                    <div className="building-icon">
                                      <img
                                        src="/images/icon/location_white.png"
                                        alt={propertyDetail.location}
                                      />
                                    </div>
                                    <div className="content-size-div project_banner_info_size mt4">
                                      <p className="capitalize">
                                        {propertyDetail.location}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </section>

            {(propertyDetail.highlights?.length > 0 ||
              propertyDetail.rera_number ||
              propertyDetail.document_other_data?.length > 0 ||
              propertyDetail.big_text_pain) && (
              <section
                className="reecosys-section reecosys-section-padding-main relative"
                id="reecosys-project-detail-section-3"
              >
                <div className="container-fluid">
                  <div className="overview-flex-div">
                    {propertyDetail.virtual_data?.length > 0 &&
                      propertyDetail.virtual_data[0].type == 'walk-through' && (
                        <div
                          className="section-information stickyWalkthrough"
                          data-aos="fade-in"
                          data-aos-delaly="400"
                          data-aos-duration="1000"
                        >
                          <div className="walkthrough-project-thumb relative">
                            {walkthroughVideoArray && (
                              <iframe
                                id="youtubeIframe"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  display: 'block'
                                }}
                                src={walkthroughVideoArray}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                              ></iframe>
                            )}
                            {propertyDetail.rera_number &&
                              propertyDetail.project_id != 546 &&
                              propertyDetail.project_id != 548 && (
                                <div
                                  className="project-rera-number"
                                  onClick={() => {
                                    handleInq(true)
                                    // inquiry_from_click('Rera Certificate');
                                  }}
                                  style={{
                                    cursor: 'pointer',
                                    width: 'fit-content',
                                    marginLeft: 'auto'
                                  }}
                                  title="Click to Download RERA Certificate"
                                >
                                  <p className="capitalize">
                                    RERA : {propertyDetail.rera_number}
                                  </p>
                                </div>
                              )}
                          </div>
                        </div>
                      )}
                    {propertyDetail.virtual_data?.length == 0 && (
                      <div
                        className="section-information stickyWalkthrough"
                        data-aos="fade-in"
                        data-aos-delaly="400"
                        data-aos-duration="1000"
                      >
                        <div className="walkthrough-project-thumb relative">
                          {propertyDetail.project_id != 621 && (
                            <Link
                              href="/"
                              className="relative border-radius-web"
                              style={{ display: 'block' }}
                            >
                              {propertyDetail.gallery_data && (
                                <img
                                  src={`${
                                    propertyDetail.gallery_data[0].image[
                                      propertyDetail.gallery_data[0].image
                                        ?.length - 1
                                    ].image
                                  }&w=900&h=700&q=100`}
                                  alt="Highlight Image"
                                  className=""
                                />
                              )}
                            </Link>
                          )}
                          {propertyDetail.project_id == 621 && (
                            <div className="">
                              <video
                                playsInline
                                muted
                                autoPlay
                                loop
                                preload="auto"
                                style={{ width: '100%' }}
                              >
                                <source
                                  src="/images/banners/venus-goodwill-banner.mp4"
                                  type="video/mp4"
                                />
                              </video>
                            </div>
                          )}
                        </div>
                        {propertyDetail.rera_number != null &&
                          propertyDetail.rera_number != undefined &&
                          propertyDetail.rera_number != '' &&
                          propertyDetail.project_id !== 546 &&
                          propertyDetail.project_id !== 548 && (
                            <div
                              className="project-rera-number"
                              onClick={() => {
                                handleInq(true)
                                // inquire_popup_web_toggle();
                                // inquiry_from_click('Rera Certificate');
                              }}
                              style={{
                                cursor: 'pointer',
                                width: 'fit-content',
                                marginLeft: 'auto'
                              }}
                              title="Click to Download RERA Certificate"
                            >
                              <p className="capitalize">
                                RERA : {propertyDetail.rera_number}
                              </p>
                            </div>
                          )}
                      </div>
                    )}
                    <div>
                      <div
                        className="inner-flex"
                        data-aos="fade-up"
                        data-aos-delaly="600"
                        data-aos-duration="1000"
                      >
                        <div className="section-title capitalize">
                          <h2
                            className={`project-logo-sec2 ${
                              propertyDetail.project_id == 621
                                ? 'project-logo-sec-2-small'
                                : ''
                            }`}
                          >
                            {propertyDetail?.project_logo_full && (
                              <img
                                src={propertyDetail?.project_logo_full}
                                alt=""
                              />
                            )}
                          </h2>
                        </div>
                        {propertyDetail.big_text_pain && (
                          <div className="content-size-div content-size-div-detail-section-highlight">
                            {/* <!-- <p ng-bind-html="propertyDetail.big_text_pain"> --> */}
                            <p
                              dangerouslySetInnerHTML={{
                                __html: propertyDetail.big_text_pain
                              }}
                            ></p>
                          </div>
                        )}
                        {/* <style>
                                .walkthrough-project-thumb video {
                                    width: 100%;
                                    border-radius: 1.5rem;
                                }
                            </style> */}
                      </div>
                      <div
                        className="highlights-grid-swiper-outer relative"
                        data-aos="fade-up"
                        data-aos-delaly="700"
                        data-aos-duration="1000"
                      >
                        {propertyDetail.highlights?.length > 0 && (
                          <div className="relative">
                            <div className="highlights-grid">
                              {propertyDetail.highlights?.map((data, i) => {
                                return (
                                  <div key={i}>
                                    <div>
                                      {data.tag_line && data.name && (
                                        <div className="content-size-div">
                                          <p className="capitalize">
                                            {data.name}&nbsp;{data.tag_line}
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className="download-button-filled-ul"
                        data-aos="fade-up"
                        data-aos-delaly="800"
                        data-aos-duration="1000"
                      >
                        <ul>
                          {propertyDetail.project_id == 602 && (
                            <li className="">
                              <a
                                className="fancybox"
                                data-fancybox={propertyDetail.slug}
                                // data-fancybox="walk-through"
                                data-type="iframe"
                                href="https://venusinfra.in/the-planet-360/"
                                // onClick={() => {
                                //   if (typeof window !== "undefined") {
                                //     import("@fancyapps/ui").then(
                                //       ({ Fancybox }) => {
                                //         Fancybox.show(
                                //           [
                                //             {
                                //               src: "https://venusinfra.in/the-planet-360/",
                                //               type: "iframe",
                                //             },
                                //           ],
                                //           {
                                //             Carousel: {
                                //               infinite: false,
                                //             },
                                //           }
                                //         );
                                //       }
                                //     );
                                //   }
                                // }}
                              >
                                <div className="outline-div-button button-div">
                                  <button className="button-style black-btn">
                                    <span className="material-symbols-outlined">
                                      360
                                    </span>
                                    <p className="capitalize">Virtual Tour</p>
                                  </button>
                                </div>
                              </a>
                            </li>
                          )}
                          <li
                            onClick={() => {
                              // inquire_popup_web_toggle();
                              // detailInquiryClick();
                              handleInq(true)
                            }}
                          >
                            <div className="filled-div-button button-div">
                              <button className="button-style black-btn">
                                <span className="material-symbols-outlined">
                                  call
                                </span>
                                {propertyDetail.project_id == 621 && (
                                  <p className="capitalize">Enquire Now</p>
                                )}
                                {propertyDetail.project_id != 621 && (
                                  <p className="capitalize">
                                    {propertyDetail.project_id == 602
                                      ? 'Register your Interest'
                                      : 'Inquire Now'}
                                  </p>
                                )}
                              </button>
                            </div>
                          </li>
                          {propertyDetail.document_other_data &&
                            propertyDetail.document_other_data?.map(
                              (download_data, i) => {
                                return (
                                  propertyDetail.document_other_data?.length >
                                    0 &&
                                  download_data.type != 'Rera Certificate' && (
                                    <li
                                      key={i}
                                      onClick={() => {
                                        // "inquire_popup_web_toggle(); inquiry_from_click(download_data.type);"
                                        handleInq(true)
                                      }}
                                    >
                                      <div className="outline-div-button button-div">
                                        <button className="button-style black-btn">
                                          <span className="material-symbols-outlined">
                                            download
                                          </span>
                                          <p className="capitalize">
                                            {download_data.type}
                                          </p>
                                        </button>
                                      </div>
                                    </li>
                                  )
                                )
                              }
                            )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}
            {(propertyDetail.project_id == 546 ||
              propertyDetail.project_id == 548) && (
              <section
                className="reecosys-section relative"
                data-aos="fade-up"
                data-aos-delaly="400"
                data-aos-duration="1000"
                id="reecosys-project-detail-section-4"
              >
                <div className="overflow">
                  {/* <div
                      className="inner-flex  inner-flex-center"
                      style={{ textAlign: "center" }}
                    >
                      <div
                        className="section-information"
                        ng-if="video.title || video.tag_line"
                        style="width: fit-content;margin: 0 auto;"
                      >
                        <div className="section-title" ng-if="video.tag_line">
                          <h2 className="" ng-bind-html="video.tag_line"></h2>
                        </div>
                      </div>
                    </div> */}

                  <div className="w100">
                    {propertyDetail.project_id == '546' && (
                      <div className="relative full-width-video-sample">
                        <video
                          autoPlay
                          muted
                          playsInline
                          id="sampleVideo546"
                          style={{
                            width: '100%',
                            display: 'block',
                            objectFit: 'cover'
                          }}
                          className="gallery-images image-cover"
                        >
                          <source
                            src="/images/pahel/sample-house.mp4"
                            type="video/mp4"
                          />
                        </video>
                        {/* {mediaTab === "media-sample-house" && (
                            <div
                              className="continue-watching-overlay-wrapper"
                              ng-className="{'continue-watching-overlay-wrapper-active': isSampleTrue546}"
                            >
                              <div
                                className="continue-watch-btn"
                                onClick="continueWatching('sampleVideo546', 'isSampleTrue546')"
                              >
                                <span className="material-symbols-outlined white-color">
                                  play_circle
                                </span>
                                <p className="white-color">Continue Watching</p>
                              </div>
                            </div>
                          )} */}
                      </div>
                    )}
                    {propertyDetail.project_id == '548' && (
                      <div className="relative full-width-video-sample">
                        <video
                          autoPlay
                          muted
                          playsInline
                          id="sampleVideo546"
                          style={{
                            width: '100%',
                            display: 'block',
                            objectFit: 'cover'
                          }}
                          className="gallery-images image-cover"
                        >
                          <source
                            src="/images/pashmina/sample-house.mp4"
                            type="video/mp4"
                          />
                        </video>
                        {/* <div className="continue-watching-overlay-wrapper" ng-if="mediaTab === 'media-sample-house'"
                              ng-className="{'continue-watching-overlay-wrapper-active' : isSampleTrue548}">
                              <div className="continue-watch-btn"
                                  ng-click="continueWatching('sampleVideo548', 'isSampleTrue548')">
                                  <span className="material-symbols-outlined white-color">
                                      play_circle
                                  </span>
                                  <p className="white-color">Continue Watching</p>
                              </div>
                          </div> */}
                      </div>
                    )}
                  </div>
                  <div className="container">
                    {propertyDetail.rera_number != null &&
                      propertyDetail.rera_number != undefined &&
                      propertyDetail.rera_number != '' && (
                        <div
                          className="project-rera-number"
                          onClick={() => {
                            // "inquire_popup_web_toggle(); inquiry_from_click('Rera Certificate');"
                            setIsOpenInq(true)
                          }}
                          style={{
                            cursor: 'pointer',
                            width: 'fit-content',
                            marginLeft: 'auto'
                          }}
                          title="Click to Download RERA Certificate"
                        >
                          <p className="capitalize">
                            RERA : {propertyDetail.rera_number}
                          </p>
                        </div>
                      )}
                  </div>
                </div>
              </section>
            )}
            {propertyDetail.gallery_data[0].image?.length > 0 && (
              // is_section_Scrolled &&
              <section
                className={`reecosys-section reecosys-section-padding-main relative ${
                  propertyDetail.project_id == 602 ? 'pt0' : ''
                }`}
                data-aos="fade-up"
                data-aos-delaly="600"
                data-aos-duration="1000"
                id="reecosys-project-detail-section-5"
              >
                {propertyDetail.gallery_data?.length > 0 &&
                  propertyDetail.gallery_data?.map((gallery, i) => {
                    return (
                      gallery.image?.length > 0 && (
                        // gallery_get == "" &&
                        <div
                          key={i}
                          className="reecosys-section"
                          id="reecosys-detail-section-gallery"
                        >
                          <div className=" container-fluid">
                            <div className="inner-flex inner-flex-center">
                              <div
                                className="relative w100"
                                data-aos="fade-up"
                                data-aos-delaly="400"
                                data-aos-duration="1000"
                              >
                                {(gallery.title || gallery.tag_line) && (
                                  <div className="section-information relative">
                                    {gallery.tag_line &&
                                      gallery.tag_line != 'undefined' && (
                                        <div className="section-title gallery-section-title-flex relative">
                                          <h2
                                            dangerouslySetInnerHTML={{
                                              __html: gallery.tag_line
                                            }}
                                          ></h2>
                                        </div>
                                      )}
                                  </div>
                                )}
                              </div>
                              {(interiorArray?.length > 0 ||
                                exteriorArray?.length > 0) && (
                                <>
                                  {/* Tabs */}
                                  <div
                                    className="project-gallery-tab-flex"
                                    data-aos="fade-up"
                                    data-aos-delay="600"
                                    data-aos-duration="1000"
                                  >
                                    {interiorArray?.length > 0 && (
                                      <div
                                        className={`project-gallery-tab-btn content-size-div ${
                                          categoryTitle === 'interior'
                                            ? 'active'
                                            : ''
                                        }`}
                                        onClick={() =>
                                          handleGalleryCategory('interior')
                                        }
                                      >
                                        <p className="semibold-fonts">
                                          Interior
                                        </p>
                                      </div>
                                    )}
                                    {exteriorArray?.length > 0 &&
                                      propertyDetail.project_id != 621 && (
                                        <div
                                          className={`project-gallery-tab-btn content-size-div ${
                                            categoryTitle === 'exterior'
                                              ? 'active'
                                              : ''
                                          }`}
                                          onClick={() =>
                                            handleGalleryCategory('exterior')
                                          }
                                        >
                                          <p className="semibold-fonts">
                                            Exterior
                                          </p>
                                        </div>
                                      )}
                                  </div>

                                  {/* Gallery */}
                                  {/* <div
                                    className={`gallery_grid ${
                                      (categoryTitle === 'interior' &&
                                        interiorArray?.length <= 2) ||
                                      (categoryTitle === 'exterior' &&
                                        exteriorArray?.length <= 2)
                                        ? 'gallery_grid_2'
                                        : ''
                                    }`}
                                  >
                                    {(categoryTitle === 'interior'
                                      ? interiorArray
                                      : exteriorArray
                                    )?.map((img, index) => (
                                      <div
                                        className={`gallery_image border-radius-web ${
                                          index < 6 ? 'active' : ''
                                        }`}
                                        key={img.image_id || index}
                                      >
                                        <a
                                          data-fancybox="gallery_all_image"
                                          href={img.image_full}
                                          target="_blank"
                                        >
                                          <img
                                            src={`${img.image}&w=900&h=800&q=100`}
                                          />
                                        </a>
                                      </div>
                                    ))}
                                  </div> */}
                                  {/* <div className="gallery_grid">
                                    {[...interiorArray, ...exteriorArray]?.map(
                                      (img, index) => (
                                        <div
                                          className={`gallery_image border-radius-web ${
                                            // Only show active tab images
                                            (categoryTitle === 'interior' &&
                                              interiorArray.includes(img)) ||
                                            (categoryTitle === 'exterior' &&
                                              exteriorArray.includes(img))
                                              ? index < 11
                                                ? 'active'
                                                : 'hidden'
                                              : 'hidden'
                                          }`}
                                          key={img.image_id || index}
                                        >
                                          <a
                                            data-fancybox="gallery_all_image"
                                            href={img.image_full}
                                            target="_blank"
                                          >
                                            <img
                                              src={`${img.image}&w=900&h=800&q=100`}
                                            />
                                          </a>
                                        </div>
                                      )
                                    )}
                                  </div> */}
                                  <div className="gallery_grid">
                                    {[...interiorArray, ...exteriorArray]?.map(
                                      (img, index) => {
                                        const isInterior =
                                          interiorArray.includes(img)
                                        const isExterior =
                                          exteriorArray.includes(img)

                                        const interiorIndex = isInterior
                                          ? interiorArray.indexOf(img)
                                          : -1
                                        const exteriorIndex = isExterior
                                          ? exteriorArray.indexOf(img)
                                          : -1

                                        const isActive =
                                          (categoryTitle === 'interior' &&
                                            isInterior &&
                                            interiorIndex < 6) ||
                                          (categoryTitle === 'exterior' &&
                                            isExterior &&
                                            exteriorIndex < 6)

                                        const isVisible = isActive
                                          ? 'active'
                                          : 'hidden'

                                        return (
                                          <div
                                            className={`gallery_image border-radius-web bg-gray ${isVisible}`}
                                            key={img.image_id || index}
                                          >
                                            <a
                                              data-fancybox="gallery_all_image"
                                              data-aos="fade-in"
                                              data-aos-delay="600"
                                              data-aos-duration="1000"
                                              href={img.image_full}
                                              target="_blank"
                                            >
                                              <img
                                                className=""
                                                src={`${img.image}&w=900&h=800&q=100`}
                                              />
                                            </a>
                                          </div>
                                        )
                                      }
                                    )}
                                  </div>
                                </>
                              )}
                              {/* {propertyDetail.gallery_data[0].image?.length >
                                6 && (
                                <div className="outline-div-button  button-div wfc m0auto viewAllBtn">
                                  {propertyDetail.gallery_data[0].image?.map(
                                    (gallery_image, i) => {
                                      return (
                                        <a
                                          key={i}
                                          data-fancybox="gallery_all_image_btn"
                                          href={gallery_image.image_full}
                                          target="_blank"
                                          className={i !== 0 ? 'hidden' : ''}
                                        >
                                          <button className=" button-style black-btn">
                                            <p>
                                              View All Images{' ('}
                                              {
                                                propertyDetail.gallery_data[0]
                                                  .image?.length
                                              }
                                              {')'}
                                            </p>
                                          </button>
                                        </a>
                                      )
                                    }
                                  )}
                                </div>
                              )} */}
                              {propertyDetail.gallery_data[0].image?.length >
                                6 && (
                                <div className="outline-div-button button-div wfc m0auto viewAllBtn">
                                  <button
                                    className="button-style black-btn"
                                    onClick={() => {
                                      // Trigger click on the first visible image in the group
                                      document
                                        .querySelector(
                                          '[data-fancybox="gallery_all_image"]'
                                        )
                                        ?.click()
                                    }}
                                  >
                                    <p>
                                      View All Images (
                                      {
                                        propertyDetail.gallery_data[0].image
                                          ?.length
                                      }
                                      )
                                    </p>
                                  </button>
                                </div>
                              )}
                              <div className="mob-3d-icon container">
                                {propertyDetail.virtual_data?.map(
                                  (video, i) => {
                                    return (
                                      propertyDetail.virtual_data?.length > 0 &&
                                      video.type == 'virtual-tour' && (
                                        <div
                                          key={i}
                                          className="outline-div-button button-div"
                                        >
                                          <a
                                            data-fancybox="walk-through"
                                            data-type="iframe"
                                            data-href={video.url}
                                            href="javascript:void(0)"
                                            target="_self"
                                            className="fancybox button-style orange-button"
                                          >
                                            <button className="button-style orange-button ">
                                              <p>
                                                <span className="bold">
                                                  360&deg;
                                                </span>
                                                Virtual Tour
                                              </p>
                                            </button>
                                          </a>
                                        </div>
                                      )
                                    )
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )
                  })}
              </section>
            )}
            {propertyDetail.amenities_data &&
              // is_section_Scrolled &&
              propertyDetail.project_id != 547 &&
              propertyDetail.project_id != 602 && (
                <section
                  className="reecosys-section relative"
                  id="reecosys-project-detail-section-6"
                >
                  {propertyDetail.project_id == '590' && (
                    <div className="container overflow">
                      <div
                        className="inner-flex inner-flex-center"
                        style={{ textAlign: 'center' }}
                      >
                        <div
                          className="section-information"
                          style={{ width: 'fit-content', margin: '0 auto' }}
                        >
                          <div
                            className="section-title"
                            data-aos="fade-up"
                            data-aos-delaly="400"
                            data-aos-duration="1000"
                          >
                            <h2
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: propertyDetail.amenities_tagline || ''
                              }}
                            ></h2>
                          </div>
                        </div>
                        {!isMobilescreen && (
                          <div
                            className="amenities-thumb-grid-swiper--outer relative"
                            data-aos="fade-up"
                            data-aos-delaly="600"
                            data-aos-duration="1000"
                          >
                            <Swiper
                              modules={[
                                Navigation,
                                Pagination,
                                Autoplay,
                                Keyboard,
                                Scrollbar
                              ]}
                              observer={true}
                              observeParents={true}
                              slidesPerView={4}
                              spaceBetween={30}
                              speed={1500}
                              autoplay={{
                                delay: 6000,
                                disableOnInteraction: false
                              }}
                              breakpoints={{
                                1152: {
                                  slidesPerView: 4
                                },
                                767: {
                                  slidesPerView: 3
                                },
                                500: {
                                  slidesPerView: 1
                                },
                                0: {
                                  slidesPerView: 1
                                }
                              }}
                              navigation={{
                                nextEl: '.swiper-button-next.amenities-next',
                                prevEl: '.swiper-button-prev.amenities-prev'
                              }}
                              scrollbar={{
                                el: '.swiper-scrollbar.swiper-scrollbar-amenities',
                                hide: false
                              }}
                              className="swiper-amenities"
                            >
                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/deshna/gym.jpg"
                                      alt="Gym"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Gym</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>

                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/deshna/childreans-play-area.jpg"
                                      alt="Children's Play Area"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Children's Play Area</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>

                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/deshna/indoor-games.jpg"
                                      alt="Indoor Game"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Indoor Game</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>

                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/deshna/walking-area.jpg"
                                      alt="Gathering Lawn"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Gathering Lawn</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>
                            </Swiper>
                            <div className="swiper-scrollbar swiper-scrollbar-amenities"></div>
                          </div>
                        )}
                        {isMobilescreen && (
                          <div
                            className="amen amenities-thumb-grid"
                            data-aos="fade-up"
                            data-aos-delaly="600"
                            data-aos-duration="1000"
                          >
                            <div className="amenities-thumb-card relative">
                              <div className="amenities-thumb-image border-radius-web relative">
                                <img src="/images/deshna/gym.jpg" alt="" />
                              </div>
                              <div className="amenitites-thumb-label-flex">
                                <div className="content-size-div">
                                  <p>Gym</p>
                                </div>
                              </div>
                            </div>

                            <div className="amenities-thumb-card relative">
                              <div className="amenities-thumb-image border-radius-web relative">
                                <img
                                  src="/images/deshna/childreans-play-area.jpg"
                                  alt=""
                                />
                              </div>
                              <div className="amenitites-thumb-label-flex">
                                <div className="content-size-div">
                                  <p>Children's Play Area</p>
                                </div>
                              </div>
                            </div>

                            <div className="amenities-thumb-card relative">
                              <div className="amenities-thumb-image border-radius-web relative">
                                <img
                                  src="/images/deshna/indoor-games.jpg"
                                  alt=""
                                />
                              </div>
                              <div className="amenitites-thumb-label-flex">
                                <div className="content-size-div">
                                  <p>Indoor Game</p>
                                </div>
                              </div>
                            </div>

                            <div className="amenities-thumb-card relative">
                              <div className="amenities-thumb-image border-radius-web relative">
                                <img
                                  src="/images/deshna/walking-area.jpg"
                                  alt=""
                                />
                              </div>
                              <div className="amenitites-thumb-label-flex">
                                <div className="content-size-div">
                                  <p>Gathering Lawn</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div
                          className="amenities-view-btn view-more-less"
                          data-aos="fade-up"
                          data-aos-delaly="600"
                          data-aos-duration="1000"
                        >
                          {propertyDetail.amenities_data?.length >= 7 && (
                            <div
                              className="outline-div-button button-div"
                              onClick={() => {
                                setView_moreless_toggleF(true)
                              }}
                            >
                              <button className="button-style black-btn">
                                <p className="capitalize">View All Amenities</p>
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {propertyDetail.project_id != '590' &&
                    propertyDetail.project_id != '546' && (
                      <div className="container overflow">
                        <div
                          className="inner-flex inner-flex-center"
                          style={{ textAlign: 'center' }}
                        >
                          <div
                            className="section-information"
                            style={{ width: 'fit-content', margin: '0 auto' }}
                          >
                            <div
                              className="section-title"
                              data-aos="fade-up"
                              data-aos-delay="400"
                              data-aos-duration="1000"
                            >
                              <h2
                                dangerouslySetInnerHTML={{
                                  __html: propertyDetail.amenities_tagline
                                }}
                              />
                            </div>
                          </div>
                          {!isMobilescreen && (
                            <div
                              className="amenities-thumb-grid-swiper--outer relative"
                              data-aos="fade-up"
                              data-aos-delaly="600"
                              data-aos-duration="1000"
                            >
                              <Swiper
                                modules={[
                                  Navigation,
                                  Pagination,
                                  Autoplay,
                                  Keyboard,
                                  Scrollbar
                                ]}
                                observer={true}
                                observeParents={true}
                                slidesPerView={4}
                                spaceBetween={30}
                                speed={1500}
                                autoplay={{
                                  delay: 6000,
                                  disableOnInteraction: false
                                }}
                                breakpoints={{
                                  1152: {
                                    slidesPerView: 4
                                  },
                                  500: {
                                    slidesPerView: 1
                                  },
                                  0: {
                                    slidesPerView: 1
                                  }
                                }}
                                navigation={{
                                  nextEl: '.swiper-button-next.amenities-next',
                                  prevEl: '.swiper-button-prev.amenities-prev'
                                }}
                                scrollbar={{
                                  el: '.swiper-scrollbar.swiper-scrollbar-amenities',
                                  hide: false
                                }}
                                className="swiper-amenities"
                              >
                                <SwiperSlide>
                                  <div className="amenities-thumb-card relative">
                                    <div className="amenities-thumb-image border-radius-web relative">
                                      <img
                                        src="/images/icon/amenities/aminities-thumb-images/gym.jpg"
                                        alt="Gym"
                                      />
                                    </div>
                                    <div className="amenitites-thumb-label-flex">
                                      <div className="content-size-div">
                                        <p>Gym</p>
                                      </div>
                                    </div>
                                  </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                  <div className="amenities-thumb-card relative">
                                    <div className="amenities-thumb-image border-radius-web relative">
                                      <img
                                        src="/images/icon/amenities/aminities-thumb-images/play-area.jpg"
                                        alt="Children's Play Area"
                                      />
                                    </div>
                                    <div className="amenitites-thumb-label-flex">
                                      <div className="content-size-div">
                                        <p>Children's Play Area</p>
                                      </div>
                                    </div>
                                  </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                  <div className="amenities-thumb-card relative">
                                    <div className="amenities-thumb-image border-radius-web relative">
                                      <img
                                        src="/images/icon/amenities/aminities-thumb-images/indoor-play.jpg"
                                        alt="Indoor Game"
                                      />
                                    </div>
                                    <div className="amenitites-thumb-label-flex">
                                      <div className="content-size-div">
                                        <p>Indoor Game</p>
                                      </div>
                                    </div>
                                  </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                  <div className="amenities-thumb-card relative">
                                    <div className="amenities-thumb-image border-radius-web relative">
                                      <img
                                        src="/images/icon/amenities/aminities-thumb-images/gathering-lawn.jpg"
                                        alt="Gathering Lawn"
                                      />
                                    </div>
                                    <div className="amenitites-thumb-label-flex">
                                      <div className="content-size-div">
                                        <p>Gathering Lawn</p>
                                      </div>
                                    </div>
                                  </div>
                                </SwiperSlide>
                              </Swiper>
                              <div className="swiper-scrollbar swiper-scrollbar-amenities"></div>
                            </div>
                          )}
                          {isMobilescreen && (
                            <div
                              className="amen amenities-thumb-grid"
                              data-aos="fade-up"
                              data-aos-delay="600"
                              data-aos-duration="1000"
                            >
                              <div className="amenities-thumb-card relative">
                                <div className="amenities-thumb-image border-radius-web relative">
                                  <img
                                    src="/images/icon/amenities/aminities-thumb-images/gym.jpg"
                                    alt="Gym"
                                  />
                                </div>
                                <div className="amenitites-thumb-label-flex">
                                  <div className="content-size-div">
                                    <p>Gym</p>
                                  </div>
                                </div>
                              </div>

                              <div className="amenities-thumb-card relative">
                                <div className="amenities-thumb-image border-radius-web relative">
                                  <img
                                    src="/images/icon/amenities/aminities-thumb-images/play-area.jpg"
                                    alt="Children's Play Area"
                                  />
                                </div>
                                <div className="amenitites-thumb-label-flex">
                                  <div className="content-size-div">
                                    <p>Children's Play Area</p>
                                  </div>
                                </div>
                              </div>

                              <div className="amenities-thumb-card relative">
                                <div className="amenities-thumb-image border-radius-web relative">
                                  <img
                                    src="/images/icon/amenities/aminities-thumb-images/indoor-play.jpg"
                                    alt="Indoor Game"
                                  />
                                </div>
                                <div className="amenitites-thumb-label-flex">
                                  <div className="content-size-div">
                                    <p>Indoor Game</p>
                                  </div>
                                </div>
                              </div>

                              <div className="amenities-thumb-card relative">
                                <div className="amenities-thumb-image border-radius-web relative">
                                  <img
                                    src="/images/icon/amenities/aminities-thumb-images/gathering-lawn.jpg"
                                    alt="Gathering Lawn"
                                  />
                                </div>
                                <div className="amenitites-thumb-label-flex">
                                  <div className="content-size-div">
                                    <p>Gathering Lawn</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {propertyDetail.amenities_data?.length >= 7 && (
                            <div
                              className="amenities-view-btn view-more-less"
                              data-aos="fade-up"
                              data-aos-delay="600"
                              data-aos-duration="1000"
                            >
                              <div
                                className="outline-div-button button-div"
                                onClick={() => {
                                  setView_moreless_toggleF(true)
                                }}
                              >
                                <button className="button-style black-btn">
                                  <p className="capitalize">
                                    View All Amenities
                                  </p>
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                  {propertyDetail.project_id == '546' && (
                    <div className="container overflow">
                      <div
                        className="inner-flex inner-flex-center"
                        style={{ textAlign: 'center' }}
                      >
                        <div
                          className="section-information"
                          style={{ width: 'fit-content', margin: '0 auto' }}
                        >
                          <div
                            className="section-title"
                            data-aos="fade-up"
                            data-aos-delaly="400"
                            data-aos-duration="1000"
                          >
                            <h2
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: propertyDetail?.amenities_tagline || ''
                              }}
                            ></h2>
                          </div>
                        </div>
                        {!isMobilescreen && (
                          <div
                            className="amenities-thumb-grid-swiper--outer relative"
                            data-aos="fade-up"
                            data-aos-delaly="600"
                            data-aos-duration="1000"
                          >
                            <Swiper
                              modules={[
                                Navigation,
                                Pagination,
                                Autoplay,
                                Keyboard,
                                Scrollbar
                              ]}
                              observer={true}
                              observeParents={true}
                              slidesPerView={4}
                              spaceBetween={30}
                              speed={1500}
                              autoplay={{
                                delay: 6000,
                                disableOnInteraction: false
                              }}
                              breakpoints={{
                                1152: {
                                  slidesPerView: 4
                                },
                                500: {
                                  slidesPerView: 1
                                },
                                0: {
                                  slidesPerView: 1
                                }
                              }}
                              navigation={{
                                nextEl: '.swiper-button-next.amenities-next',
                                prevEl: '.swiper-button-prev.amenities-prev'
                              }}
                              scrollbar={{
                                el: '.swiper-scrollbar.swiper-scrollbar-amenities',
                                hide: false
                              }}
                              className="swiper-amenities"
                            >
                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/icon/amenities/aminities-thumb-images/gym-pahel.jpg"
                                      alt="Gym"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Gym</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>

                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/icon/amenities/aminities-thumb-images/play-area-pahel.jpg"
                                      alt="Children's Play Area"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Children's Play Area</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>

                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/icon/amenities/aminities-thumb-images/indoor-play-pahel.jpg"
                                      alt="Indoor Game"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Indoor Game</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>

                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/icon/amenities/aminities-thumb-images/gathering-lawn-pahel.jpg"
                                      alt="Gathering Lawn"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Gathering Lawn</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>

                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/icon/amenities/aminities-thumb-images/swimming-pool-pahel.jpg"
                                      alt="Swimming Pool"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Swimming Pool</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>

                              <SwiperSlide>
                                <div className="amenities-thumb-card relative">
                                  <div className="amenities-thumb-image border-radius-web relative">
                                    <img
                                      src="/images/icon/amenities/aminities-thumb-images/home-theatre-pahel.jpg"
                                      alt="Mini Theater"
                                    />
                                  </div>
                                  <div className="amenitites-thumb-label-flex">
                                    <div className="content-size-div">
                                      <p>Mini Theater</p>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>
                            </Swiper>
                            <div className="swiper-scrollbar swiper-scrollbar-amenities"></div>
                          </div>
                        )}
                        {isMobilescreen && (
                          <div
                            className="amen amenities-thumb-grid"
                            data-aos="fade-up"
                            data-aos-delaly="600"
                            data-aos-duration="1000"
                          >
                            <div className="amenities-thumb-card relative">
                              <div className="amenities-thumb-image border-radius-web relative">
                                <img
                                  src="/images/icon/amenities/aminities-thumb-images/gym.jpg"
                                  alt="Gym"
                                />
                                {/* <div className="amenities-overlay"></div> */}
                              </div>
                              <div className="amenitites-thumb-label-flex">
                                {/* <div className="amenities-thumb-icon">
                                      <img src="/images/icon/amenities/aminities-thumb-images/gym.svg" alt="Gym Icon" />
                                    </div> */}
                                <div className="content-size-div">
                                  <p>Gym</p>
                                </div>
                              </div>
                            </div>

                            <div className="amenities-thumb-card relative">
                              <div className="amenities-thumb-image border-radius-web relative">
                                <img
                                  src="/images/icon/amenities/aminities-thumb-images/play-area.jpg"
                                  alt="Children's Play Area"
                                />
                              </div>
                              <div className="amenitites-thumb-label-flex">
                                <div className="content-size-div">
                                  <p>Children's Play Area</p>
                                </div>
                              </div>
                            </div>

                            <div className="amenities-thumb-card relative">
                              <div className="amenities-thumb-image border-radius-web relative">
                                <img
                                  src="/images/icon/amenities/aminities-thumb-images/indoor-play.jpg"
                                  alt="Indoor Game"
                                />
                              </div>
                              <div className="amenitites-thumb-label-flex">
                                <div className="content-size-div">
                                  <p>Indoor Game</p>
                                </div>
                              </div>
                            </div>

                            <div className="amenities-thumb-card relative">
                              <div className="amenities-thumb-image border-radius-web relative">
                                <img
                                  src="/images/icon/amenities/aminities-thumb-images/gathering-lawn.jpg"
                                  alt="Gathering Lawn"
                                />
                              </div>
                              <div className="amenitites-thumb-label-flex">
                                <div className="content-size-div">
                                  <p>Gathering Lawn</p>
                                </div>
                              </div>
                            </div>

                            {/* <div
                              className="amenities-view-btn view-more-less"
                              data-aos="fade-up"
                              data-aos-delaly="600"
                              data-aos-duration="1000"
                            >
                              <div
                                className="outline-div-button button-div"
                                // onClick={onToggle}
                              >
                                <button className="button-style black-btn">
                                  <p className="capitalize">
                                    View All Amenities
                                  </p>
                                </button>
                              </div>
                            </div> */}
                          </div>
                        )}
                        <div
                          className="amenities-view-btn view-more-less"
                          data-aos="fade-up"
                          data-aos-delay="600"
                          data-aos-duration="1000"
                        >
                          <div
                            className="outline-div-button button-div"
                            onClick={() => {
                              setView_moreless_toggleF(true)
                            }}
                          >
                            <button className="button-style black-btn">
                              <p className="capitalize">View All Amenities</p>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </section>
              )}

            {propertyDetail.project_id == 602 && (
              <section
                className="reecosys-section happinessAmenityGrid relative"
                id="reecosys-project-detail-section-6"
              >
                <div className="mini-container overflow">
                  <div className="project-amenities-grid  relative">
                    <div className="amenities-block inner-flex inner-flex-medium j-c-sb">
                      <div
                        className=""
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        data-aos-delay="400"
                      >
                        {propertyDetail.amenities_title && (
                          <div className="section-paragraph ">
                            <p className="capitalize wfc relative line-after-text ">
                              {propertyDetail.amenities_title}
                            </p>
                          </div>
                        )}
                        {propertyDetail.amenities_tagline && (
                          <div className="section-title  capitalize ">
                            <h2 className="uppercase ">
                              {propertyDetail.amenities_tagline}
                            </h2>
                          </div>
                        )}
                      </div>
                      {isMobilescreen &&
                        propertyDetail.amenities_images[0].image && (
                          <div
                            className="amenities-banner border-radius-web relative"
                            data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-delay="600"
                          >
                            <img
                              src={`${propertyDetail.amenities_images[0].image}&w=670&h=570&q=100"`}
                              style={{ height: '100%' }}
                              alt={propertyDetail.project_title}
                            />
                          </div>
                        )}
                      <div
                        className="amenities-grid"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        data-aos-delay="600"
                      >
                        {propertyDetail.amenities_data?.map((amenities, i) => {
                          return (
                            <div className="" key={i}>
                              <div className="amenities-icon ">
                                <img
                                  src={amenities.icon}
                                  alt={amenities.amenity}
                                />
                              </div>
                              <div className="content-size-div">
                                <p className="capitalize text-left">
                                  {amenities.amenity}
                                </p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    {!isMobilescreen && (
                      <div
                        className="amenities-banner  border-radius-web relative"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        data-aos-delay="600"
                      >
                        {propertyDetail.amenities_images[0].image && (
                          <img
                            src={`${propertyDetail.amenities_images[0].image}&w=670&h=570&q=100`}
                            style={{ height: '100%' }}
                            alt={propertyDetail.project_title}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </section>
            )}
            {propertyDetail.project_id == '548' && (
              <section
                className="reecosys-section relative reecosys-section-padding-main"
                id="reecosys-project-detail-section-11"
              >
                <div className=" overflow">
                  <div className="inner-flex">
                    <div
                      className="flex-row alc j-c-sb container-fluid"
                      data-aos="fade-up"
                      data-aos-delaly="400"
                      data-aos-duration="1000"
                    >
                      <div>
                        <div className="section-title capitalize ">
                          <h2>
                            Real Stories, <br />
                            Real Satisfaction
                          </h2>
                        </div>
                      </div>
                      <div className="blogNavigation flex-row alc hidden-xs">
                        <div className="swiper-button-prev testimonial-prev">
                          <span className="material-symbols-outlined">
                            west
                          </span>
                        </div>
                        <div className="swiper-button-next testimonial-next">
                          <span className="material-symbols-outlined">
                            east
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="project_video_swiper"
                      data-aos="fade-up"
                      data-aos-delaly="600"
                      data-aos-duration="1000"
                    >
                      <Swiper
                        modules={[
                          Navigation,
                          Pagination,
                          Autoplay,
                          Keyboard,
                          Scrollbar
                        ]}
                        observer={true}
                        observeParents={true}
                        slidesPerView={4}
                        spaceBetween={30}
                        speed={1500}
                        autoplay={false}
                        scrollbar={{
                          el: '.swiper-scrollbar.project_video_scrollbar',
                          hide: false
                        }}
                        navigation={{
                          nextEl: '.swiper-button-next.testimonial-next',
                          prevEl: '.swiper-button-prev.testimonial-prev'
                        }}
                        breakpoints={{
                          1152: { slidesPerView: 3.75 },
                          991: { slidesPerView: 3 },
                          500: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                            freeMode: true
                          },
                          0: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                            freeMode: true
                          }
                        }}
                      >
                        <SwiperSlide>
                          <a
                            data-fancybox="projects-video"
                            href="https://youtu.be/1wdX75hsz0I?si=jmLbI3wEXIU5UrBR"
                            target="_self"
                          >
                            <div className="relative project_video_div">
                              <div className="project_video_image project_video_image_testimonial border-radius-web relative">
                                <img
                                  src="/images/pashmina/testimonials/1.jpg"
                                  alt=""
                                />
                                <div className="video_play_btn">
                                  <img src="/images/icon/play.svg" alt="" />
                                </div>
                                <div className="black_overlay"></div>
                              </div>
                              <div className="project_text">
                                <p>Ankit Shah</p>
                              </div>
                            </div>
                          </a>
                        </SwiperSlide>

                        <SwiperSlide>
                          <a
                            data-fancybox="projects-video"
                            href="https://youtu.be/w6c5AY09WmY?si=kVp2iNRrsKguWEX6"
                            target="_self"
                          >
                            <div className="relative project_video_div">
                              <div className="project_video_image project_video_image_testimonial border-radius-web relative">
                                <img
                                  src="/images/pashmina/testimonials/2.jpg"
                                  alt=""
                                />
                                <div className="video_play_btn">
                                  <img src="/images/icon/play.svg" alt="" />
                                </div>
                                <div className="black_overlay"></div>
                              </div>
                              <div className="project_text">
                                <p>Hiren Patel</p>
                              </div>
                            </div>
                          </a>
                        </SwiperSlide>

                        <SwiperSlide>
                          <a
                            data-fancybox="projects-video"
                            href="https://youtu.be/3WDYP3EsfKs?si=L0ZZSc_OC_NeqIq1"
                            target="_self"
                          >
                            <div className="relative project_video_div">
                              <div className="project_video_image project_video_image_testimonial border-radius-web relative">
                                <img
                                  src="/images/pashmina/testimonials/3.jpg"
                                  alt=""
                                />
                                <div className="video_play_btn">
                                  <img src="/images/icon/play.svg" alt="" />
                                </div>
                                <div className="black_overlay"></div>
                              </div>
                              <div className="project_text">
                                <p>Abhishek Kucheria</p>
                              </div>
                            </div>
                          </a>
                        </SwiperSlide>

                        <SwiperSlide>
                          <a
                            data-fancybox="projects-video"
                            href="https://youtu.be/YZ5QsREoLu0?si=mlBt2bNyA6WMVFSS"
                            target="_self"
                          >
                            <div className="relative project_video_div">
                              <div className="project_video_image project_video_image_testimonial border-radius-web relative">
                                <img
                                  src="/images/pashmina/testimonials/4.jpg"
                                  alt=""
                                />
                                <div className="video_play_btn">
                                  <img src="/images/icon/play.svg" alt="" />
                                </div>
                                <div className="black_overlay"></div>
                              </div>
                              <div className="project_text">
                                <p>Ketan Parsaniya</p>
                              </div>
                            </div>
                          </a>
                        </SwiperSlide>

                        <SwiperSlide>
                          <a
                            data-fancybox="projects-video"
                            href="https://youtu.be/6_icVNa3DLQ?si=wXOG4vA0-Ot1rB0R"
                            target="_self"
                          >
                            <div className="relative project_video_div">
                              <div className="project_video_image project_video_image_testimonial border-radius-web relative">
                                <img
                                  src="/images/pashmina/testimonials/5.jpg"
                                  alt=""
                                />
                                <div className="video_play_btn">
                                  <img src="/images/icon/play.svg" alt="" />
                                </div>
                                <div className="black_overlay"></div>
                              </div>
                              <div className="project_text">
                                <p>Mit Pandya</p>
                              </div>
                            </div>
                          </a>
                        </SwiperSlide>
                      </Swiper>
                      <div className="swiper-scrollbar project_video_scrollbar visible-xs "></div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {
              // is_section_Scrolled &&
              (propertyDetail.project_id == '590' ||
                propertyDetail.project_id == '602' ||
                propertyDetail.project_id == '621') && (
                <section
                  className="reecosys-section DetailconstructionSection  reecosys-section-padding-main "
                  id="reecosys-project-detail-section-constructionupdate"
                  style={{ backgroundImage: 'unset !important' }}
                >
                  <div className="">
                    <div className="container relative">
                      <div className="construction-update-card-grid">
                        <div
                          className="constructionUpdateFlex flex-row alc"
                          data-aos="fade-up"
                          data-aos-delaly="400"
                          data-aos-duration="1000"
                        >
                          <div>
                            <div className="inner-flex">
                              <div className="section-title capitalize">
                                <h2
                                  className={
                                    isMobilescreen ? 'text-align-center' : ''
                                  }
                                >
                                  {propertyDetail.construction?.title}:
                                  <br />
                                  {propertyDetail.construction?.tag_line}
                                </h2>
                              </div>
                              <div
                                className="deshnaConstructionSwiper"
                                style={{ overflow: 'hidden' }}
                              >
                                {getConstructionData(propertyDetail.project_id)
                                  ?.length > 0 && (
                                  <>
                                    <Swiper
                                      modules={[
                                        Navigation,
                                        Pagination,
                                        Autoplay,
                                        Keyboard,
                                        Scrollbar
                                      ]}
                                      observeParents={true}
                                      observer={true}
                                      slidesPerView={1}
                                      spaceBetween={10}
                                      autoplay={{
                                        delay: 3000,
                                        disableOnInteraction: false
                                      }}
                                    >
                                      {getConstructionData(
                                        propertyDetail.project_id
                                      )?.map((data, index) => (
                                        <SwiperSlide key={index}>
                                          <div className="constructionImg border-radius-web">
                                            <a
                                              data-fancybox="deshnaConstructionImages"
                                              href={data.image}
                                              target="_self"
                                            >
                                              <img
                                                src={data.image}
                                                alt={`Construction Image - ${
                                                  index + 1
                                                }`}
                                              />
                                            </a>
                                          </div>
                                        </SwiperSlide>
                                      ))}
                                    </Swiper>
                                  </>
                                )}
                                <div className="content-size-div">
                                  {propertyDetail.project_id == '590' && (
                                    <p
                                      className={`semibold-fonts ${
                                        isMobilescreen
                                          ? 'text-align-center'
                                          : 'text-right'
                                      }`}
                                    >
                                      Progress As on 16th June 2025
                                    </p>
                                  )}
                                  {propertyDetail.project_id == '602' && (
                                    <p
                                      className={`semibold-fonts ${
                                        isMobilescreen
                                          ? 'text-align-center'
                                          : 'text-right'
                                      }`}
                                    >
                                      Progress As on 2nd June 2025
                                    </p>
                                  )}
                                  {propertyDetail.project_id == '621' && (
                                    <p
                                      className={`semibold-fonts ${
                                        isMobilescreen
                                          ? 'text-align-center'
                                          : 'text-right'
                                      }`}
                                    >
                                      Progress As on 30th May 2025
                                    </p>
                                  )}
                                </div>
                              </div>

                              {videoLink ? (
                                <a
                                  data-fancybox="construction-gallery"
                                  href={videoLink}
                                  target="_self"
                                  className="wfc deshnaConstructionBtn"
                                  style={{ display: 'block !important' }}
                                >
                                  <div className="outline-div-button button-div wfc">
                                    <button className="button-style black-btn wfc">
                                      <span className="material-symbols-outlined">
                                        play_circle
                                      </span>
                                      <p className="capitalize">
                                        View Latest Update
                                      </p>
                                    </button>
                                  </div>
                                </a>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                          <div className="wfc m0auto">
                            <div className="progress-statuss">
                              {propertyDetail.construction.progress_percent >
                                0 && (
                                <div
                                  className="progress"
                                  id="progress"
                                  data-percentage={
                                    propertyDetail.construction.progress_percent
                                  }
                                >
                                  <span className="progress-left">
                                    <span className="progress-bar"></span>
                                  </span>
                                  <span className="progress-right">
                                    <span className="progress-bar"></span>
                                  </span>
                                  <div
                                    className="section-title progress-value value_get"
                                    id="counter"
                                  >
                                    <h2
                                      className="regular_fonts counter-value"
                                      data-count={
                                        propertyDetail.construction
                                          .progress_percent
                                      }
                                    >
                                      {
                                        propertyDetail.construction
                                          .progress_percent
                                      }
                                    </h2>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )
            }
            {(propertyDetail.location_tag_line ||
              propertyDetail.proximity_data?.proximity_array?.length > 0) && (
              <section
                className="reecosys-section reecosys-section-padding-main relative darkgray-bg "
                id="reecosys-project-detail-section-lcoation-div"
              >
                <div className="container-fluid" id="project_location">
                  <div className="locationFlex">
                    {(propertyDetail.location_tag_line ||
                      propertyDetail.address_description) && (
                      <div className="section-information location_text ">
                        <div className="section-information">
                          {propertyDetail.location_tag_line && (
                            <div
                              className="section-title capitalize"
                              data-aos="fade-up"
                              data-aos-delaly="400"
                              data-aos-duration="1000"
                            >
                              <h2>{propertyDetail.location_tag_line}</h2>
                            </div>
                          )}
                          <br />
                          <br />
                          <div
                            className="section-information"
                            data-aos="fade-up"
                            data-aos-delaly="600"
                            data-aos-duration="1000"
                          >
                            <div className="flex-row alc">
                              <span className="material-symbols-outlined">
                                <img
                                  src="/images/footer/location2.svg"
                                  alt="Location Icon"
                                />
                              </span>
                              <div className="link-font-size">
                                <p> Site Address </p>
                              </div>
                            </div>
                            {propertyDetail.address_description && (
                              <div className=" content-size-div">
                                <p
                                  className="location-paragraph"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      propertyDetail?.address_description || ''
                                  }}
                                ></p>
                              </div>
                            )}
                          </div>
                          <br />
                          <br />
                          <div
                            className="emailFlexlocation"
                            data-aos="fade-up"
                            data-aos-delaly="800"
                            data-aos-duration="1000"
                          >
                            <div className="section-information">
                              <div className="flex-row alc">
                                <span className="material-symbols-outlined">
                                  <img
                                    src="/images/footer/email2.svg"
                                    alt="Email Icon"
                                  />
                                </span>
                                <div className="link-font-size">
                                  <p> Email Address </p>
                                </div>
                              </div>
                              {propertyDetail.project_contact_email && (
                                <div className="content-size-div">
                                  <p className="">
                                    <a
                                      href={`mailto:${propertyDetail.project_contact_email}"`}
                                    >
                                      {propertyDetail.project_contact_email}
                                    </a>
                                  </p>
                                </div>
                              )}
                            </div>
                            <div className="section-information">
                              <div className="flex-row alc">
                                <span className="material-symbols-outlined">
                                  <img
                                    src="/images/footer/call2.svg"
                                    alt="Call Icon"
                                  />
                                </span>
                                <div className="link-font-size">
                                  <p> Phone Number </p>
                                </div>
                              </div>
                              {propertyDetail.project_contact_no && (
                                <div className=" content-size-div  ">
                                  <p className="">
                                    <a
                                      href={`tel:+${propertyDetail.project_contact_no}`}
                                    >
                                      +{propertyDetail.project_contact_no}
                                    </a>
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {propertyDetail?.map_iframe && (
                      <div
                        className="project-map-iframe detail-map border-radius-web relative"
                        data-aos="fade-in"
                        data-aos-delaly="600"
                        data-aos-duration="1000"
                      >
                        <iframe
                          src={propertyDetail.map_iframe}
                          style={{ border: 0 }}
                          allowFullScreen
                          className="lazyload"
                          data-aos="fade-in"
                          data-aos-duration="600"
                          data-aos-delay="1200"
                        ></iframe>
                      </div>
                    )}
                  </div>
                </div>
              </section>
            )}

            <section
              id="project-detial-inquiry-section"
              className="reecosys-section-padding-main"
            >
              <div className="mini-container">
                <Project_details_form
                  projects_full_list_detail={propertyDetail}
                  // countryList={countryList}
                />
                {/* <div ng-include='"templates/forms/project_detail_inquiry.html"'></div> */}
              </div>
            </section>
          </div>
          <div
            className={`quickEnquiryOverlay ${
              view_moreless_toggleF ? 'inqury_active' : ''
            }`}
            onClick={() => {
              view_moreless_toggle_close()
            }}
          ></div>
          <div
            className={`amenities_popup ${
              view_moreless_toggleF ? 'more_active' : ''
            }`}
          >
            <div className="relative">
              <div className="all-amenities-grid-detail">
                <div className="amenities-close-icon-div-new">
                  <div
                    className="amenities-close-icon"
                    onClick={() => {
                      view_moreless_toggle_close()
                    }}
                  >
                    <img
                      src="/images/icon/close.png"
                      alt={propertyDetail.project_title}
                    />
                  </div>
                </div>
                <div className="section-information">
                  {propertyDetail.amenities_title && (
                    <div className="content-size-div">
                      <p
                        className="title-color capitalize"
                        dangerouslySetInnerHTML={{
                          __html: propertyDetail?.amenities_title || ''
                        }}
                      ></p>
                    </div>
                  )}
                  {propertyDetail.amenities_tagline && (
                    <div className="section-title">
                      <h2
                        dangerouslySetInnerHTML={{
                          __html: propertyDetail?.amenities_tagline || ''
                        }}
                      ></h2>
                    </div>
                  )}
                </div>
                <div className="all-amenites-list">
                  <ul>
                    {propertyDetail.amenities_data?.map((amenities, i) => (
                      <li key={i}>
                        <div className="amenities-icon">
                          <img
                            src={amenities.icon}
                            alt={propertyDetail.project_title}
                            className="lazyload"
                          />
                        </div>
                        <div className="amenities-text">
                          <p>{amenities.amenity}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {!isMobilescreen && (
            <div ref={bottomStripRef} className="bottomStrip" id="bottomStrip">
              <div className="bottomStripFlex ">
                <div className="hidden-xs hidden-sm">
                  <div className="section-content ">
                    <Link
                      href="/projects"
                      className="flex-row content-size-div-2 project-btn-flex-bottom-strip"
                    >
                      <span className="material-symbols-outlined gray-color">
                        chevron_left
                      </span>
                      <p className="gray-color uppercase"> Projects</p>
                    </Link>
                  </div>
                  <div className="section-title-2">
                    <h2
                      className="uppercase"
                      style={{ textTransform: 'uppercase !important' }}
                    >
                      {propertyDetail.project_title}
                    </h2>
                  </div>
                </div>
                <div className="bottomSubFlex hidden-xs hidden-sm">
                  <div className="">
                    <div className="content-size-div-2">
                      <p className="uppercase gray-color">Property Type</p>
                    </div>
                    <div className="section-title-2">
                      <h2 className="">{propertyDetail.size_price}</h2>
                    </div>
                  </div>
                  <div className="">
                    <div className="content-size-div-2">
                      <p className="uppercase gray-color">Location</p>
                    </div>
                    <div className="section-title-2">
                      <h2 className="">{propertyDetail.location}</h2>
                    </div>
                  </div>
                </div>
                <div className="bottomEnquirybtn">
                  <div className="outline-div-button button-div">
                    <button
                      onClick={() => {
                        handleInq(true)
                      }}
                      className="button-style download-fill-button new-btn-black-venus"
                    >
                      {propertyDetail.project_id != 621 && (
                        <p className="capitalize lora-regular">
                          {propertyDetail.project_id == 602
                            ? 'Register your Interest'
                            : 'Inquire Now'}
                        </p>
                      )}
                      {propertyDetail.project_id == 621 && (
                        <p className="capitalize lora-regular">Enquire Now</p>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isMobilescreen && (
            <div ref={bottomStripRef} className="bottomStrip" id="bottomStrip">
              <div
                className="filled-div-button button-div w100"
                onClick={() => {
                  handleInq(true)
                }}
              >
                <button
                  className="button-style black-btn "
                  style={{ width: '100%' }}
                >
                  <span className="material-symbols-outlined">call</span>
                  {propertyDetail.project_id != 621 && (
                    <p className="capitalize">
                      {propertyDetail.project_id == 602
                        ? 'Register your Interest'
                        : 'Inquire Now'}
                    </p>
                  )}
                  {propertyDetail.project_id == 621 && (
                    <p className="capitalize">Enquire Now</p>
                  )}
                </button>
              </div>
            </div>
          )}

          <div ref={floatingBtnRef} className="floating_btn">
            <a
              target="_blank"
              href="https://api.whatsapp.com/send?phone=7452074520&text=Hi,%20I%20contacted%20you%20Through%20your%20website"
            >
              <div className="contact_icon">
                <img src="/images/footer/whatsapp-floating.svg" alt="" />
              </div>
            </a>
          </div>
        </div>
        {/* ) : (
          <div className="section-title">
            <h4>Loading Property data...</h4>
          </div>
        )} */}
      </div>
    </>
  )
}

export default Project_details
